//Gestion iframe
var iframesFullS = document.querySelectorAll(".s-iframe-full");
function iframeFullS(iframe){   
    var ratioWtH = 0.5625;
    var ratioHtW = 1.7777777777777778;
    var parent = iframe.closest(".content-iframe"); 
    var iWidth = parseInt(iframe.getAttribute("data-init-width"));
    var iHeight = parseInt(iframe.getAttribute("data-init-height")); 
 
    var horizontal = true; 
    if(iWidth < iHeight){
        horizontal = false; 
    }else{ 
        if(iWidth != 1920 || iHeight != 1080){
            ratioHtW = iWidth / iHeight + 0.1;
            ratioWtH = iHeight / iWidth + 0.1;   
        }
    }

    var newH = "";
    var newW = "";
    if(horizontal){ 
        var calWidth = parent.offsetHeight * ratioHtW; 
        newW = calWidth;
        newH = parent.offsetHeight; 
        if(newW < parent.offsetWidth){
            newW = parent.offsetWidth;
            newH = parent.offsetWidth * ratioWtH;
        }
        iframe.style.height = newH + "px";
        iframe.style.width = newW + "px";
    }else{ 
        var calWidth = parent.offsetHeight * ratioWtH; 
        newW = calWidth;
        newH = parent.offsetHeight; 
        if(newW < parent.offsetWidth){
            newW = parent.offsetWidth;
            newH = parent.offsetWidth * ratioHtW;
        }
        iframe.style.height = newH + "px";
        iframe.style.width = newW + "px"; 
    }
    //repositionnement
    if(newW > parent.offsetWidth){
        iframe.style.left = -((newW - parent.offsetWidth) / 2) + "px";
    }else{
        iframe.style.left = "0px";
    }
    if(newH > parent.offsetHeight){
        iframe.style.top = -((newH - parent.offsetHeight) / 2) + "px";
    }else{
        iframe.style.top = "0px";
    } 
} 

iframesFullS.forEach(i => {
    iframeFullS(i);
});

window.addEventListener("resize", function(){
    iframesFullS.forEach(i => {
        iframeFullS(i);
    });
});  
var prehome = document.querySelector(".content-pre-home");
if(prehome != null){ 
    prehome.querySelector(".btn-shop").addEventListener("click", function(){
        document.querySelector("body").classList.remove("prehome"); 
        prehome.classList.add("enter");
        iframesFullS.forEach(i => {
            iframeFullS(i);
        });
    }); 
    
    document.querySelector('.content-pre-home').style.height = window.innerHeight + "px";     
} 

if(window.innerHeight > window.screen.height){
    location.reload();
}
 